<template>
  <b-tabs>
    <b-tab title="Budgeting Planners" @click="openPlanner">
      <forms-list-activity
          v-if="loadedBudgetingPlanner"
          ref="budgetingPlannerList"
          :context="context"
          :custom-data-loader="dataLoader"
          :form-type="FORM_TYPE"
          :recordsWithChosenFilters="recordsWithChosenFilters"
          :show-add="false"
          :show-details="false"
          :toolbox-mixins="toolbox"
      >
      </forms-list-activity>
    </b-tab>
    <b-tab title="Budgeting Planners PM" active>
      <BudgetingPlannerListPM ref="PmPlanner"></BudgetingPlannerListPM>
    </b-tab>
  </b-tabs>

</template>

<script>
import Activity from "@/activity/Activity";
import FormsListActivity from "@/activity/templates/layouts/forms/FormsListActivity";
import FormsLoader from "@/components/forms/FormsLoader";
import BudgetingPlanner from "@/server/com/silkplm/model/plm/BudgetingPlanner";
import BudgetingPlannerListPM from "@/components/forms/customizations/plm/BudgetingPlannerListPM";
import {ToolboxButton} from "@/components/navbar/toolbox/ToolboxButton";
import {BudgetingPlannerWithCategoryAndSeason} from "@/components/forms/customizations/plm/BudgetingPlannerWithCategoryAndSeason";
import _ from "lodash";
import ActivityManager from "@/activity/ActivityManager";
import RelatedRecordsException from "@/server/com/silkplm/rpc/exceptions/RelatedRecordsException";
import DialogManager from "@/utils/DialogManager";
import Category from "@/server/com/silkplm/model/plm/Category";

const ImportDataToGrid = () => require("@/components/plm/ImportDataToGrid");


const FORM_TYPE = BudgetingPlanner;

export default {
  name: "BudgetingPlannerList",
  components: {FormsListActivity, BudgetingPlannerListPM},
  permission: () => FormsLoader.formPermission(FORM_TYPE),

  async created() {

  },
  async mounted() {
    this.$onInsert(BudgetingPlanner, async (changeEvent) => {
      let plannerCategory = await changeEvent.instance.getCategoryEntity();
      if (plannerCategory.categoryParentId) {
        let seasonId = changeEvent.instance.seasonId;
        let categoryId = plannerCategory.categoryParentId;
        let planner = await Rpc.plm.services.BudgetingPlannerService.findBudgetingPlannerBySeasonAndCategory(seasonId, categoryId);
        if (!planner) {
          await Rpc.plm.services.BudgetingPlannerService.createBudgetingPlannerSummaryLevelUpCategory(changeEvent.instance, categoryId);
        }
      }
      await this.$refs.budgetingPlannerList.$refs.entititesList.refresh();
    });
  },


  methods: {
    ...Activity.methods,

    getTitle() {
      return this.$refs.budgetingPlannerList?.getTitle() ?? $tr('budgetingPlannerList.planners','Budgeting planners');
    },

    async openImportFile() {
      await ActivityManager.showActivity(ImportDataToGrid);
    },

    async deleteAllBudgetingPlanners() {
      this.disabledTrash = !this.disabledTrash;
      if (this.$refs.budgetingPlannerList.$refs.entititesList.$refs.grid.items.length) {
        if (await DialogManager.yesNo($tr('budgetingPlannerList.deleting.all','Deleting all budgeting planners'),
            $tr('budgetingPlannerList.sure.delete','Are you sure you want to delete all budgeting planners?'))) {
          try {
            await Rpc.plm.services.BudgetingPlannerService.deleteAllBudgetingPlanners();
          } catch (e) {
            if (e instanceof RelatedRecordsException) {
              await DialogManager.info($tr('budgetingPlannerList.cannot.all.delete','All budgeting planners cannot be deleted.'),
                  $tr('budgetingPlannerList.info.cannot.all.delete','All budgeting planners cannot be deleted, because as some are referenced from orders.'));
            }
          }
        }
      }
    },

    async loadData(entitiesList, refreshOptions) {
      /*
        let refreshOptions = {
          activeFilters: this.activeFilters,
          hasFilters: this.hasFilters,
        }
       */
      let categoryFilterLevel = 0;
      let isActivePMResponsibleForTheGroupFilter = false;
      if (refreshOptions?.hasFilters) {
        for (let index = 0; index < refreshOptions.activeFilters.length; index++) {
          let filter = refreshOptions.activeFilters[index];
          if (filter.fieldName === "category") {
            let categoryId = refreshOptions.activeFilters[index].filterSpec.idValues[0];
            let treePathCategoryList = await Rpc.Forms.getTreePathElements(this.categoryFormConfig.formClassLong, categoryId);
            categoryFilterLevel = treePathCategoryList.length;
          }
          if (filter.fieldName === "PMResponsibleForTheGroup") {
            isActivePMResponsibleForTheGroupFilter = true;
          }
        }
      }

      let formConfig = await FormsLoader.detectFormConfig(FORM_TYPE);
      let array;
      if (refreshOptions?.hasFilters) {
        array = await Rpc.Forms.listExtendedEntitiesWithColFilters(formConfig.formClassLong, refreshOptions.activeFilters);
      } else {
        array = await Rpc.Forms.listExtendedEntities(formConfig.formClassLong);
      }
      let summariesWithCategory = [];
      let budgetingPlannersWithCategoryAndSeason = [];
      let budgetingPlannersWithIncorrectLeavesOfCategories = [];
      let numberOfMatches = 0;
      let plannerCategory;
      let plannerSeason;
      let categoryParentId;

      for (let planner of array) {
        plannerCategory = await planner.getCategoryEntity();
        plannerSeason = await planner.getSeasonIdEntity();
        categoryParentId = plannerCategory.categoryParentId;
        let plannerWithCategoryAndSeason = new BudgetingPlannerWithCategoryAndSeason();
        plannerWithCategoryAndSeason.budgetingPlanner = planner;
        plannerWithCategoryAndSeason.category = plannerCategory;
        plannerWithCategoryAndSeason.season = plannerSeason;

        if (categoryParentId === null) {
          summariesWithCategory.push(plannerWithCategoryAndSeason);
        } else {
          budgetingPlannersWithCategoryAndSeason.push(plannerWithCategoryAndSeason);
        }
      }

      // podsumowania
      let finalResultWithCategories = [];

      summariesWithCategory.sort((a, b) => {
        if (a.season.season.toUpperCase() === b.season.season.toUpperCase()) {
          return a.category.categoryName.toUpperCase() > b.category.categoryName.toUpperCase() ? 1 : -1;
        }
        return a.season.season.toUpperCase() > b.season.season.toUpperCase() ? 1 : -1;
      });
      finalResultWithCategories = [...summariesWithCategory];

      while (budgetingPlannersWithCategoryAndSeason.length) {
        numberOfMatches = 0;
        for (let index = 0; index < finalResultWithCategories.length; index++) {
          let leaves = [];
          for (let plannerWithCategory of budgetingPlannersWithCategoryAndSeason) {
            if (plannerWithCategory.budgetingPlanner.seasonId === finalResultWithCategories[index].budgetingPlanner.seasonId &&
                plannerWithCategory.category.categoryParentId === finalResultWithCategories[index].category.id) {
              leaves.push(plannerWithCategory);
              numberOfMatches++;
            }
          }

          leaves.sort((a, b) => {
            if (a.season.season.toUpperCase() === b.season.season.toUpperCase()) {
              return a.category.categoryName.toUpperCase() > b.category.categoryName.toUpperCase() ? 1 : -1;
            }
            return a.season.season.toUpperCase() > b.season.season.toUpperCase() ? 1 : -1;
          })

          for (let indexLeaf = 0; indexLeaf < leaves.length; indexLeaf++) {
            finalResultWithCategories.splice(index + 1 + indexLeaf, 0, leaves[indexLeaf]);
          }
        }

        if (numberOfMatches === 0) {
          for (let plannerWithCategory of budgetingPlannersWithCategoryAndSeason) {
            plannerWithCategory.deleted = true;
            budgetingPlannersWithIncorrectLeavesOfCategories.push(plannerWithCategory);
          }

          let tempList = [];
          for (let plannerWithCategory of budgetingPlannersWithCategoryAndSeason) {
            if (!plannerWithCategory?.deleted) {
              tempList.push(plannerWithCategory);
            }
          }
          budgetingPlannersWithCategoryAndSeason = tempList;
        }

        for (let plannerWithCategory of budgetingPlannersWithCategoryAndSeason) {
          for (let planner of finalResultWithCategories) {
            if (plannerWithCategory?.budgetingPlanner?.id === planner.budgetingPlanner.id) {
              plannerWithCategory.deleted = true;
            }
          }
        }
        let tempList = [];
        for (let index = 0; index < budgetingPlannersWithCategoryAndSeason.length; index++) {
          if (!budgetingPlannersWithCategoryAndSeason[index]?.deleted) {
            tempList.push(budgetingPlannersWithCategoryAndSeason[index]);
          }
        }
        budgetingPlannersWithCategoryAndSeason = tempList;
      }

      let finalResult = [];
      for (let plannerWithCategory of finalResultWithCategories) {
        for (let summary of summariesWithCategory) {
          if (plannerWithCategory.category.categoryParentId === summary.category.id) {
            plannerWithCategory.budgetingPlanner.__row_conf = {cssClass: "secondSummary"};
          }
        }
        finalResult.push(plannerWithCategory.budgetingPlanner);
      }

      for (let plannerWithCategory of budgetingPlannersWithIncorrectLeavesOfCategories) {
        let found_elem = _.findLast(finalResult, (el) => {
          return el.seasonId === plannerWithCategory.budgetingPlanner.seasonId;
        });
        let index = _.findIndex(finalResult, (e) => {
          return e.id === found_elem?.id;
        }, 0);


        if (categoryFilterLevel !== 3) {
          plannerWithCategory.budgetingPlanner.__row_conf = {cssClass: "bg-danger"};
        }
        finalResult.splice(index + 1, 0, plannerWithCategory.budgetingPlanner);
      }

      for (let planner of finalResult) {
        for (let summary of summariesWithCategory) {
          if (planner.id === summary.budgetingPlanner.id) {
            planner.__row_conf = {cssClass: "firstSummary"};
          }
        }
      }
      if (refreshOptions.hasFilters) {
        if (isActivePMResponsibleForTheGroupFilter) {
          for (let planner of finalResult) {
            planner.__row_conf = {cssClass: ""};
          }
          return finalResult;
        }
        if (categoryFilterLevel === 2) {
          for (let planner of finalResult) {
            let plannerCategoryTree = await Rpc.Forms.getTreePathElements(this.categoryFormConfig.formClassLong, planner.category);
            let plannerCategoryLevel = plannerCategoryTree.length;
            if (plannerCategoryLevel === 2) {
              planner.__row_conf = {cssClass: "secondSummary"};
            }
          }
        }

      }
      return finalResult;
    },

    async openPlanner() {
      this.loadedBudgetingPlanner = true;
    }
  },

  props: {
    context: {default: null},
    recordsWithChosenFilters: {default: null}
  },

  data: function () {
    const that = this;
    let toolbox = [];
    this.formConfig = FormsLoader.formByType(BudgetingPlanner);
    if (this.formConfig.writePermitted) {
      let importButton = new ToolboxButton().withIcon("file-arrow-up").withLabel($tr("import","Import")).withGroup("A")
          .setToggleType().withToggled(false).withToggle(async () => await this.openImportFile());
      toolbox.push(importButton);
    }

    return {
      loadedBudgetingPlanner: false,
      toolbox: [...toolbox],
      FORM_TYPE,
      dataLoaded: false,
      categoryFormConfig: FormsLoader.formByType(Category),
      dataLoader: function (...args) {
        return that.loadData(...args);
      },
    }
  },

}
</script>
